import { Injectable, inject, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // null = not checked yet, true/false = login state
  isLoggedIn = signal<boolean | null>(null);
  private platformId = inject(PLATFORM_ID);

  constructor() {
    this.checkAuth();
  }
  
  checkAuth() {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('authToken');
      this.isLoggedIn.set(!!token); // true if token exists, false if not
    } else {
      this.isLoggedIn.set(null); // fallback for server
    }
  }
}
